import {http, onSuccess, onFail} from "./http";

export const clientImportExcel = (eventKey, data, params) => {
    return http.post(`/api/cp/event/${eventKey}/client/import`, data, params)
        .then(onSuccess, onFail);
}
